import React from 'react';
import { Link } from 'react-router-dom';

const BrandPage = () => (
  <main data-testid="brand-page" className="pt-24">
    <section className="py-24">
      <div className="max-w-5xl mx-auto px-6">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-4">Link Building</p>
        <h1 className="text-4xl md:text-6xl font-bold tracking-tight mb-8">
          Brand Kit<br />
          <span className="text-zinc-500">& Risorse</span>
        </h1>
        
        <p className="text-xl text-zinc-400 mb-16 max-w-2xl">
          Tutto il necessario per supportare, promuovere e finanziare 
          la fase di startup dell'associazione &lt;/AI_covo.tech&gt;®.
        </p>

        {/* Logo Section */}
        <div className="mb-20">
          <h2 className="text-2xl font-bold mb-8 flex items-center gap-3">
            <span className="text-[#00FF41]">01</span> Logo
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-[#0A0A0A] border border-white/10 p-8 flex flex-col items-center justify-center gap-3">
              <div className="text-center">
                <p className="font-mono font-black text-3xl md:text-4xl text-[#00FF41]" style={{ textShadow: '0 0 20px rgba(0,255,65,0.3)' }}>
                  &lt;/AI_covo.tech&gt;<sup style={{ fontSize: '0.4em', verticalAlign: 'super', marginLeft: '2px', fontWeight: 400, color: '#00FF41', fontFamily: 'Georgia, serif' }}>&reg;</sup>
                </p>
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] font-black mt-1 text-white">DIGITAL HUB SOCIALE</p>
              </div>
            </div>
            <div className="bg-white p-8 flex flex-col items-center justify-center gap-3">
              <div className="text-center">
                <p className="font-mono font-black text-3xl md:text-4xl text-[#00FF41]">
                  &lt;/AI_covo.tech&gt;<sup style={{ fontSize: '0.4em', verticalAlign: 'super', marginLeft: '2px', fontWeight: 400, color: '#00FF41', fontFamily: 'Georgia, serif' }}>&reg;</sup>
                </p>
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] font-black mt-1 text-[#1B2A4A]">DIGITAL HUB SOCIALE</p>
              </div>
            </div>
          </div>
          <div className="mt-6 grid md:grid-cols-3 gap-4">
            <a href="/logo_aicovo_transparent.png" download="AI_covo_tech_logo.png" className="btn-primary text-center block">
              Download PNG (Trasparente)
            </a>
            <a href="/logo_aicovo.svg" download="AI_covo_tech_logo.svg" className="btn-primary text-center block">
              Download SVG (Vettoriale)
            </a>
            <button className="btn-primary opacity-50 cursor-not-allowed">PDF (coming soon)</button>
          </div>
        </div>

        {/* Colors Section */}
        <div className="mb-20">
          <h2 className="text-2xl font-bold mb-8 flex items-center gap-3">
            <span className="text-[#00FF41]">02</span> Colori
          </h2>
          <div className="grid md:grid-cols-4 gap-4">
            <div>
              <div className="h-24 bg-[#00FF41] mb-4"></div>
              <p className="font-mono text-sm text-white">Matrix Green</p>
              <p className="font-mono text-xs text-zinc-500">#00FF41</p>
              <p className="font-mono text-xs text-zinc-500">RGB: 0, 255, 65</p>
            </div>
            <div>
              <div className="h-24 bg-[#050505] border border-white/10 mb-4"></div>
              <p className="font-mono text-sm text-white">Cave Black</p>
              <p className="font-mono text-xs text-zinc-500">#050505</p>
              <p className="font-mono text-xs text-zinc-500">RGB: 5, 5, 5</p>
            </div>
            <div>
              <div className="h-24 bg-[#0A0A0A] border border-white/10 mb-4"></div>
              <p className="font-mono text-sm text-white">Surface</p>
              <p className="font-mono text-xs text-zinc-500">#0A0A0A</p>
              <p className="font-mono text-xs text-zinc-500">RGB: 10, 10, 10</p>
            </div>
            <div>
              <div className="h-24 bg-white mb-4"></div>
              <p className="font-mono text-sm text-white">White</p>
              <p className="font-mono text-xs text-zinc-500">#FFFFFF</p>
              <p className="font-mono text-xs text-zinc-500">RGB: 255, 255, 255</p>
            </div>
          </div>
        </div>

        {/* Typography Section */}
        <div className="mb-20">
          <h2 className="text-2xl font-bold mb-8 flex items-center gap-3">
            <span className="text-[#00FF41]">03</span> Tipografia
          </h2>
          <div className="space-y-8">
            <div className="bg-[#0A0A0A] border border-white/10 p-8">
              <p className="text-zinc-500 text-sm mb-2">Headings</p>
              <p className="text-4xl font-black" style={{fontFamily: 'Chivo, sans-serif'}}>Chivo Black</p>
              <p className="font-mono text-xs text-zinc-500 mt-4">
                Google Fonts: fonts.google.com/specimen/Chivo
              </p>
            </div>
            <div className="bg-[#0A0A0A] border border-white/10 p-8">
              <p className="text-zinc-500 text-sm mb-2">Body Text</p>
              <p className="text-2xl" style={{fontFamily: 'IBM Plex Sans, sans-serif'}}>IBM Plex Sans</p>
              <p className="font-mono text-xs text-zinc-500 mt-4">
                Google Fonts: fonts.google.com/specimen/IBM+Plex+Sans
              </p>
            </div>
            <div className="bg-[#0A0A0A] border border-white/10 p-8">
              <p className="text-zinc-500 text-sm mb-2">Monospace / Code / UI Accents</p>
              <p className="text-2xl font-mono">JetBrains Mono</p>
              <p className="font-mono text-xs text-zinc-500 mt-4">
                Google Fonts: fonts.google.com/specimen/JetBrains+Mono
              </p>
            </div>
          </div>
        </div>

        {/* Naming Section */}
        <div className="mb-20">
          <h2 className="text-2xl font-bold mb-8 flex items-center gap-3">
            <span className="text-[#00FF41]">04</span> Naming & Tagline
          </h2>
          <div className="bg-[#0A0A0A] border border-white/10 p-8 space-y-6">
            <div>
              <p className="text-zinc-500 text-sm mb-2">Nome Principale</p>
              <p className="text-3xl font-black font-mono text-[#00FF41]">&lt;/AI_covo.tech&gt;<sup style={{ fontSize: '0.4em', verticalAlign: 'super', marginLeft: '2px', fontWeight: 400, fontFamily: 'Georgia, serif' }}>&reg;</sup></p>
            </div>
            <div>
              <p className="text-zinc-500 text-sm mb-2">Brand Name</p>
              <p className="text-3xl font-bold font-mono text-[#00FF41]">&lt;/AI_covo.tech&gt;<sup style={{ fontSize: '0.4em', verticalAlign: 'super', marginLeft: '2px', fontWeight: 400, fontFamily: 'Georgia, serif' }}>&reg;</sup></p>
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] font-black mt-2 text-white">DIGITAL HUB SOCIALE</p>
            </div>
            <div>
              <p className="text-zinc-500 text-sm mb-2">Tagline</p>
              <p className="text-xl text-zinc-300 italic">"Molto più di un coworking"</p>
            </div>
            <div>
              <p className="text-zinc-500 text-sm mb-2">Descrizione Estesa</p>
              <p className="text-zinc-400">
                Associazione Culturale · Doposcuola · Formazione Digitale · Academy
              </p>
            </div>
          </div>
        </div>

        {/* Funding Request Section */}
        <div className="mb-20">
          <h2 className="text-2xl font-bold mb-8 flex items-center gap-3">
            <span className="text-[#00FF41]">05</span> Richiesta Fondi Startup
          </h2>
          <div className="bg-[#00FF41]/5 border border-[#00FF41]/30 p-8 neon-border">
            <h3 className="text-2xl font-bold text-[#00FF41] mb-6">Budget Fase Iniziale</h3>
            
            <div className="space-y-4 mb-8">
              <div className="flex justify-between items-center py-4 border-b border-white/10">
                <span className="text-zinc-300">Allestimento sede</span>
                <span className="font-mono text-[#00FF41]">€ 8.000</span>
              </div>
              <div className="flex justify-between items-center py-4 border-b border-white/10">
                <span className="text-zinc-300">Attrezzature tecnologiche</span>
                <span className="font-mono text-[#00FF41]">€ 5.000</span>
              </div>
              <div className="flex justify-between items-center py-4 border-b border-white/10">
                <span className="text-zinc-300">Materiale didattico</span>
                <span className="font-mono text-[#00FF41]">€ 2.000</span>
              </div>
              <div className="flex justify-between items-center py-4 border-b border-white/10">
                <span className="text-zinc-300">Comunicazione e marketing</span>
                <span className="font-mono text-[#00FF41]">€ 1.500</span>
              </div>
              <div className="flex justify-between items-center py-4 border-b border-white/10">
                <span className="text-zinc-300">Spese legali e costituzione</span>
                <span className="font-mono text-[#00FF41]">€ 1.000</span>
              </div>
              <div className="flex justify-between items-center py-4 border-b border-white/10">
                <span className="text-zinc-300">Fondo operativo 6 mesi</span>
                <span className="font-mono text-[#00FF41]">€ 2.500</span>
              </div>
              <div className="flex justify-between items-center py-4 bg-[#00FF41]/10 px-4 -mx-4">
                <span className="text-white font-bold text-lg">TOTALE</span>
                <span className="font-mono text-[#00FF41] text-2xl font-bold">€ 20.000</span>
              </div>
            </div>

            <p className="text-zinc-400 text-sm mb-6">
              Questi fondi ci permetteranno di avviare le attività entro 3 mesi dalla raccolta 
              e garantire operatività per il primo anno.
            </p>

            <Link to="/dona" className="btn-primary bg-[#00FF41] text-black border-[#00FF41] hover:bg-[#33FF66] block text-center">
              Contribuisci al Progetto
            </Link>
          </div>
        </div>

        {/* Download All */}
        <div className="bg-[#0A0A0A] border border-white/10 p-8 text-center">
          <h3 className="text-xl font-bold mb-4">Scarica tutto il Brand Kit</h3>
          <p className="text-zinc-500 mb-6">Logo, colori, tipografie, presentazione progetto</p>
          <button className="btn-primary opacity-50 cursor-not-allowed">
            Download ZIP (coming soon)
          </button>
        </div>
      </div>
    </section>
  </main>
);

export default BrandPage;
